import { IconBaseProps, IconType } from "@/types/icon";

export const CartSolidIcon: IconType = ({
  size = 24,
  color = "text-white", // 기본 색상을 흰색으로 설정
  ...props
}: IconBaseProps) => {
  return (
    <svg
      className={`${color} w-[${size}px] h-[${size}px]`}
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        fillRule="evenodd"
        d="M4 4a1 1 0 0 1 1-1h1.5a1 1 0 0 1 .979.796L7.939 6H19a1 1 0 0 1 .979 1.204l-1.25 6a1 1 0 0 1-.979.796H9.605l.208 1H17a3 3 0 1 1-2.83 2h-2.34a3 3 0 1 1-4.009-1.76L5.686 5H5a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </svg>
  );
};
